import { angular, app } from '../app.module'
app.controller('BrandCtrl', ($rootScope, $scope, $timeout, $filter, BrandService) => {
  // テーブルクエリ設定
  $scope.query = {
    order: 'totalFollowers',
    limit: 25,
    options: [10, 25, 50],
    page: 1,
  }
  // md-row-select 用の選択状態
  $scope.selected = []
  // キーワード
  $scope.keywordFilter = null
  // メッセージをリセットする
  $rootScope.messageFilter = null

  /**
   * getBrands ブランドのデータを取得
   * @return {void}
   */
  function getBrands() {
    BrandService.BrandData.getBrands($rootScope.groupId).then((brands) => {
      // ブランドデータをセットしてスコープに保存
      $scope.allBrands = BrandService.BrandData.setBrandData(brands)

      if (!$rootScope.isPro) {
        $scope.allBrands = $scope.allBrands.filter((brand) => !brand.isEmpty)
      }

      $scope.filterCategory($scope.allBrands, $scope.query.page)
    })
  }

  /**
   * resetPanigation ソートしたらページングを1に戻す
   * @return {void}
   */
  $scope.resetPanigation = function () {
    $timeout(() => {
      // ページングを初期化
      $scope.query.page = 1
    })
  }

  /**
   * onPaginate ページングを移動するイベント
   * @return {void}
   */
  $scope.onPaginate = function () {
    angular.element('body').scrollTop(80)
  }

  // ディレクティブから'changeBrandsList'を受信した場合
  $rootScope.$on('changeBrandsList', () => {
    getBrands()
  })

  // カテゴリが変更された場合の処理
  $scope.$on('changeBrandCategory', (event, categoryInfo) => {
    if (categoryInfo.type !== 'brand') {
      return
    }
    // 選択したメインカテゴリ、サブカテゴリをセット
    $scope.categoryName = null
    $scope.subCategoryName = null

    // メインカテゴリがある場合、スコープへカテゴリ、サブカテゴリを格納
    if (categoryInfo !== null) {
      $scope.categoryName = categoryInfo.categoryName
      $scope.subCategoryName =
        categoryInfo.subCategoryName !== '指定しない' ? categoryInfo.subCategoryName : null
    }

    // ブランド一覧がある場合、大カテゴリフィルタリング
    if ($scope.allBrands !== undefined) {
      $scope.filterCategory($scope.allBrands, 1)
    } else {
      // ロード中フラグ
      $scope.isLoading = true
      // カテゴリ一覧を取得
      getBrands()
    }
  })

  // ディレクティブから、'changeFilterData'を受信した場合
  $scope.$on('changeFilterData', (event, filterInfo) => {
    if (filterInfo.type === 'subCategoryFilter') {
      // ブランドのサブカテゴリではない場合は、リターン
      if (filterInfo.subCategoryType !== 'brand') {
        return
      }
      $scope.subCategoryName = filterInfo.value
    }

    // フィルターを変更する
    changeFilter()
  })

  /**
   * キーワードの変更イベント
   * @param {string} keyword キーワード
   */
  $scope.changeKeywordFilter = (keyword: string) => {
    if ($scope.keywordFilter === keyword) {
      return
    }
    $scope.keywordFilter = keyword
    // フィルターを変更する
    changeFilter()
  }

  // カテゴリフィルタリング
  $scope.filterCategory = function (brands: {}[], page: number) {
    $scope.sortBrands = $filter('filter')(brands, (brand) => {
      // 大カテゴリフィルタリング
      if (
        $scope.categoryName !== null &&
        $scope.categoryName !== '指定しない' &&
        $scope.categoryName !== brand.brandCategoryName
      ) {
        return false
      }

      // 小カテゴリフィルタリング
      if (
        $scope.subCategoryName !== null &&
        $scope.subCategoryName !== '指定しない' &&
        $scope.subCategoryName !== brand.brandSubCategoryName
      ) {
        return false
      }

      // ブランド名フィルタリング
      if (
        $scope.keywordFilter !== null &&
        brand.brandName.match(
          new RegExp($scope.keywordFilter.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&'), 'i')
        ) === null
      ) {
        return false
      }

      return true
    })
    $scope.query.page = page
    $scope.countSortBrands = $scope.sortBrands.length
    // 取得が完了したら、ロード中フラグを下げる
    $scope.isLoading = false
  }

  /**
   * フィルターの変更
   */
  function changeFilter() {
    // カテゴリフィルタリング
    $scope.filterCategory($scope.allBrands, 1)
  }
})
